import { render, staticRenderFns } from "./refactoredExpedientesNewOrEdit.vue?vue&type=template&id=754d5dc0&scoped=true&"
import script from "./refactoredExpedientesNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./refactoredExpedientesNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./refactoredExpedientesNewOrEdit.vue?vue&type=style&index=0&id=754d5dc0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754d5dc0",
  null
  
)

export default component.exports